// extracted by mini-css-extract-plugin
export default {"logoutButton":"VdBOK"};